// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"493":"6407a070","727":"b0811d9a","981":"d94b40c3"}[chunkId] + ".css";
};